import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { withUser } from "../Contexts/user";
import Modal from "../Components/modal";
const Dashboard = ({ user }) => {
    const [isCp58ModalOpen, setIsCp58ModalOpen] = useState(false);
    const NumberFormatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const capitalizeWords = str => {
        return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };

    const cp58List = useMemo(
        () =>
            (user?.auth?.cp58List || [])
                .filter((item) => item?.url)
                .sort((a, b) => (b?.year || 0) - (a?.year || 0)),
        [user?.auth?.cp58List]
    );
    const oldCp58Url = user?.auth?.newcp58 || user?.auth?.cp58 || "";
    const hasOldCp58 = Boolean(user?.auth?.cp58 || user?.auth?.newcp58);

    return (
        <div className="lg:flex lg:mt-0 mt-8">
            <div className="flex flex-wrap rounded-2xl w-full overflow-hidden p-2 dashboard-page-shell">
                {/* Main Card Content */}
                <div className="w-full dashboard-card dashboard-home p-6">
                    {/* Header Section */}
                    <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-6 gap-4">
                        <Link to="/changepassword">
                            <button
                                style={{ backgroundColor: "#d1a866" }}
                                className="cursor-pointer hidden lg:flex items-center text-white font-bold py-1 px-4 rounded-full ml-4 dashboard-button"
                            >
                                CHANGE PASSWORD
                            </button>
                        </Link>

                        <div className="dashboard-nav-row flex flex-nowrap gap-1 w-full lg:flex lg:w-auto lg:gap-2">
                            <Link
                                to="/namecard"
                                className="dashboard-nav-link flex-1 min-w-0 lg:w-auto lg:flex-none"
                            >
                                <button
                                    style={{ border: "1px solid #d1a866" }}
                                    className="cursor-pointer w-full flex items-center justify-center font-bold py-2 px-3 rounded-full dashboard-button lg:w-40"
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "#d1a866";
                                        e.currentTarget.style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "white";
                                        e.currentTarget.style.color = "black";
                                    }}
                                >
                                    NAME CARD
                                </button>
                            </Link>
                            <Link
                                to="/portfolio"
                                className="dashboard-nav-link flex-1 min-w-0 lg:w-auto lg:flex-none"
                            >
                                <button
                                    style={{ border: "1px solid #d1a866" }}
                                    className="cursor-pointer w-full flex items-center justify-center font-bold py-2 px-3 rounded-full dashboard-button lg:w-40"
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "#d1a866";
                                        e.currentTarget.style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "white";
                                        e.currentTarget.style.color = "black";
                                    }}
                                >
                                    PORTFOLIO
                                </button>
                            </Link>
                            <Link
                                to="/album"
                                className="dashboard-nav-link flex-1 min-w-0 lg:w-auto lg:flex-none"
                            >
                                <button
                                    style={{ border: "1px solid #d1a866" }}
                                    className="cursor-pointer w-full flex items-center justify-center font-bold py-2 px-3 rounded-full dashboard-button lg:w-40"
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "#d1a866";
                                        e.currentTarget.style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "white";
                                        e.currentTarget.style.color = "black";
                                    }}
                                >
                                    ALBUM
                                </button>
                            </Link>
                            {hasOldCp58 && (
                                <a
                                    href={oldCp58Url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="dashboard-nav-link flex-1 min-w-0 lg:w-auto lg:flex-none"
                                >
                                    <button
                                        type="button"
                                        style={{ border: "1px solid #d1a866" }}
                                        className="cursor-pointer w-full flex items-center justify-center font-bold py-2 px-3 rounded-full dashboard-button lg:w-40"
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                                "#d1a866";
                                            e.currentTarget.style.color = "white";
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                                "white";
                                            e.currentTarget.style.color = "black";
                                        }}
                                    >
                                        OLD CP58
                                    </button>
                                </a>
                            )}
                            {cp58List.length > 0 && (
                                <button
                                    type="button"
                                    style={{ border: "1px solid #d1a866", width: "160px" }}
                                    className="cursor-pointer flex items-center justify-center font-bold py-1 px-4 rounded-full dashboard-button"
                                    onClick={() => setIsCp58ModalOpen(true)}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "#d1a866";
                                        e.currentTarget.style.color = "white";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.backgroundColor =
                                            "white";
                                        e.currentTarget.style.color = "black";
                                    }}
                                >
                                    CP58
                                </button>
                            )}
                        </div>
                    </div>

                    <div>
                        <h1 className="dashboard-title">
                            WELCOME, {user && user.auth.nickname !== "-" ? `${user.auth.nickname.toUpperCase()} ` : ""}{user ? `${user.auth.name.toUpperCase()}` : ""}
                        </h1>
                    </div>

                    {/* Info Grid */}
                    <div className="grid lg:grid-cols-4 gap-6 mb-6 info-grid-section">
                        <div>
                            <div className="dashboard-label">DD Code</div>
                            <div className="dashboard-value">
                                {user ? user.auth.code : ""}
                            </div>
                        </div>
                        <div>
                            <div className="dashboard-label">Designation</div>
                            <div className="dashboard-value">
                                {user
                                    ? user.auth.director === "SD"
                                        ? "Sales Director"
                                        : user.auth.director === "PD"
                                        ? "Prime Director"
                                        : user.auth.progression
                                            ? capitalizeWords(user.auth.progression)
                                            : ""
                                    : ""}
                            </div>
                        </div>
                       
                        <div>
                            <div className="dashboard-label">Branch</div>
                            <div className="dashboard-value">
                                {user ? user.auth.state.name : ""}
                            </div>
                        </div>

                        <div>
                            <div className="dashboard-label">Bank Details</div>
                            <div className="dashboard-value">
                                {user ? user.auth.bankDetails : ""} Public Bank
                            </div>
                        </div>
                    </div>

                    {/* NRIC and Contact Section */}
                    <div className="grid lg:grid-cols-4 gap-6 mb-6 info-grid-section">
                        <div>
                            <div className="dashboard-label">NRIC</div>
                            <div className="dashboard-value">
                                {user ? user.auth.ic : ""}
                            </div>
                        </div>
                        <div>
                            <div className="dashboard-label">Contact</div>
                            <div className="dashboard-value">
                                {user ? user.auth.phone : ""}
                            </div>
                        </div>
                        <div>
                            <div className="dashboard-label">Email</div>
                            <div className="dashboard-value">
                                {user ? user.auth.email : ""}
                            </div>
                        </div>
                    </div>

                    {/* Sales Section */}
                    <div className="grid lg:grid-cols-2 gap-6">
                        <div>
                            <div className="dashboard-label">
                                Personal Sales
                            </div>
                            <div className="dashboard-sales text-black text-4xl font-bold shadow-lg rounded-lg p-4 bg-gray-50">
                                RM{" "}
                                {user
                                    ? NumberFormatter.format(
                                          user.auth.personalSales
                                      )
                                    : "0.00"}
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div>
                                <div className="dashboard-label">
                                    Group Sales
                                </div>
                                <div className="dashboard-sales text-black text-4xl font-bold shadow-lg rounded-lg p-4 bg-gray-50">
                                    RM{" "}
                                    {user
                                        ? NumberFormatter.format(
                                              user.auth.groupSales
                                          )
                                        : "0.00"}
                                </div>
                            </div>
                        </div>
                            <div className="flex lg:justify-end mt-4">
                                {user && user.auth.smcDate && (
                                    <img
                                        src="https://ik.imagekit.io/dnddecpho/dndream/D&D_NewWebsiteIcon-08_wZM8C61PP.png?updatedAt=1705479724830"
                                        alt="SMC Badge"
                                        width="130"
                                        height="170"
                                    />
                                )}
                                {user &&
                                    !user.auth.smcDate &&
                                    user.auth.pmcDate && (
                                        <img
                                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_NewWebsiteIcon-07_ndLRVTUJj.png?updatedAt=1705479724449"
                                            alt="PMC Badge"
                                            width="130"
                                            height="170"
                                        />
                                    )}
                                {user &&
                                    !user.auth.smcDate &&
                                    !user.auth.pmcDate &&
                                    user.auth.emcDate && (
                                        <img
                                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_NewWebsiteIcon-06_NFhgKdZLk.png?updatedAt=1705479724841"
                                            alt="EMC Badge"
                                            width="130"
                                            height="170"
                                        />
                                    )}
                                {user &&
                                    !user.auth.smcDate &&
                                    !user.auth.pmcDate &&
                                    !user.auth.emcDate &&
                                    user.auth.omcDate && (
                                        <img
                                            src="https://ik.imagekit.io/dnddecpho/dndream/D&D_NewWebsiteIcon-05_1Crm5OU_F.png?updatedAt=1705479725122"
                                            alt="OMC Badge"
                                            width="130"
                                            height="170"
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                {isCp58ModalOpen && (
                    <Modal reset={() => setIsCp58ModalOpen(false)}>
                        <div
                            className="rounded-xl p-6 max-w-md mx-auto"
                            style={{ backgroundColor: "#1A202E" }}
                        >
                            <h2 className="text-xl font-bold text-white mb-4 text-center">
                                Select CP58 Year
                            </h2>
                            <div className="space-y-2">
                                {cp58List.map((item) => (
                                    <a
                                        key={item._id || `${item.year}-${item.url}`}
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block"
                                        onClick={() => setIsCp58ModalOpen(false)}
                                    >
                                        <button
                                            type="button"
                                            className="w-full bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 rounded-lg transition-colors"
                                        >
                                            {item.year}
                                        </button>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </Modal>
                )}
        </div>
    );
};

export default withUser(Dashboard);
